<p-dialog [(visible)]="visible" [modal]="true" [style]="{ width: '45vw' }" [contentStyle]="{ 'max-height': '80vh', 'overflow-y': 'auto' }"
  [breakpoints]="{ '960px': '65vw', '640px': '90vw' }" [draggable]="false" (onHide)="closeDialog()" [resizable]="false">

  <ng-template pTemplate="header">
    <div class="d-flex align-items-center gap-3 w-full">
      <img [src]="report()?.reportedUserInfo?.avatar || 'assets/images/profile.png'" [alt]="report()?.reportedUserInfo?.firstName" class="rounded-circle header-avatar" width="48" height="48" />
      <div class="flex-1">
        <div class="d-flex align-items-center gap-2 mb-1">
          <h3 class="m-0 text-white font-bold">{{ report()?.reportedUserInfo?.firstName }} {{ report()?.reportedUserInfo?.lastName }}</h3>
          <p-tag [value]="report()?.status" [styleClass]="getStatusSeverity(report()?.status ?? '')" />
        </div>
        <div class="d-flex align-items-center gap-3">
          <small class="text-white opacity-90">
            <i class="pi pi-envelope me-1"></i>
            {{ report()?.reportedUserInfo?.email }}
          </small>
          @if (report()?.reportedUserInfo?.createdAt) {
            <small class="text-white opacity-90">
              <i class="pi pi-calendar me-1"></i>
              Member Since: {{ report()?.reportedUserInfo?.createdAt | date:'shortDate' }}
            </small>
          }
        </div>
      </div>
    </div>
  </ng-template>

  @if (report(); as reportData) {
  <div class="report-details">
    <div class="section-container">
      <div class="section-title">
        <i class="pi pi-exclamation-circle icon-primary"></i>
        Violation summary
      </div>

      <div class="info-grid">
        <div class="info-item info-item-full">
          <span class="info-label">Reported user account status</span>
          <div class="status-row">
            <span class="status-tag" [class]="'status-' + (reportData.reportedUserInfo.accountStatus || 'active')">
              {{ (reportData.reportedUserInfo.accountStatus || 'active') | titlecase }}
            </span>
          </div>

          @if (reportData.reportedUserInfo.statusReason && reportData.reportedUserInfo.accountStatus !== 'active') {
            <div class="mt-3">
              <span class="info-label">{{ (reportData.reportedUserInfo.accountStatus | titlecase) }} Reason</span>
              <div class="description-box">{{ reportData.reportedUserInfo.statusReason }}</div>
            </div>
          }

          @if (reportData.reportedUserInfo.accountStatus === 'suspended' && reportData.reportedUserInfo.suspendedServices?.length) {
            <div class="restricted-services">
              <span class="info-label">Restricted services</span>
              <div class="service-tags">
                @for (srv of reportData.reportedUserInfo.suspendedServices; track srv) {
                  <span class="service-tag">{{ srv | titlecase }}</span>
                }
              </div>
            </div>
          }
        </div>

        <div class="info-item">
          <span class="info-label">Report reason</span>
          <span class="reason-tag" [class]="getReasonSeverity(reportData.category)">{{ reportData.category }}</span>
        </div>

        <div class="info-item">
          <span class="info-label">Report count</span>
          <span class="count-tag">{{ reportData.reportedUserInfo.totalReports || 1 }} report(s)</span>
        </div>

        <div class="info-item">
          <span class="info-label">Severity</span>
          <div>
            <p-tag [value]="getSeverityLevel(reportData.reportedUserInfo.totalReports).label" [styleClass]="getSeverityLevel(reportData.reportedUserInfo.totalReports).class"></p-tag>
          </div>
        </div>

        <div class="info-item">
          <span class="info-label">Report date</span>
          <span class="info-value">
            <i class="pi pi-calendar" style="color: var(--text-muted); margin-right: 6px;"></i>
            {{ reportData.createdAt | date:'shortDate' }}
          </span>
        </div>

        <div class="info-item">
          <span class="info-label">Report id</span>
          <span class="info-value mono">#{{ reportData._id }}</span>
        </div>

        @if (reportData.description) {
          <div class="info-item info-item-full">
            <span class="info-label">Description</span>
            <div class="description-box">{{ reportData.description }}</div>
          </div>
        }

        @if (reportData.attachments && reportData.attachments.length > 0) {
          <div class="info-item info-item-full">
            <span class="info-label">Flag content</span>
            <div class="attachment-list">
              @for (doc of reportData.attachments; track $index) {
                <a [href]="doc" target="_blank" class="attachment-preview" pTooltip="Click to view full size" tooltipPosition="top">
                  @if (isPdf(doc)) {
                    <div class="pdf-preview">PDF</div>
                  } @else {
                    <img [src]="doc" alt="Supporting document" />
                  }
                </a>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <app-moderation-action-form
      [accountStatus]="$any(reportData.reportedUserInfo.accountStatus || 'active')"
      [userName]="reportData.reportedUserInfo.firstName + ' ' + reportData.reportedUserInfo.lastName"
      [isReport]="true"
      [reportStatus]="reportData.status"
      (onAction)="handleAction($event)"
      (onCancel)="closeDialog()">
    </app-moderation-action-form>
  </div>
}
</p-dialog>